import React from 'react'

type Props = {
  className?: string
  // Stroke color; defaults to currentColor so the glyph inherits the parent's
  // `color` (e.g. the platform toggle's active/inactive treatment).
  color?: string
  size?: number
}

// Outline (hollow) Android robot for the Live Updates platform toggle (Figma
// 368:6876). Font Awesome only ships a SOLID `fa-android`, so this stroke glyph
// is a dedicated icon rather than a font variant. Decorative — the toggle
// button carries the accessible label — so it is aria-hidden.
const BrandAndroid = ({
  className,
  color = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 6.66663V10.6666"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.333 6.66663V10.6666"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 5.99996H11.3337M11.3337 5.99996C11.3337 5.1159 10.9825 4.26806 10.3573 3.64294C9.73223 3.01782 8.88438 2.66663 8.00033 2.66663C7.11627 2.66663 6.26842 3.01782 5.6433 3.64294C5.01818 4.26806 4.66699 5.1159 4.66699 5.99996V11.3333C4.66699 11.5101 4.73723 11.6797 4.86225 11.8047C4.98728 11.9297 5.15685 12 5.33366 12H10.667C10.8438 12 11.0134 11.9297 11.1384 11.8047C11.2634 11.6797 11.3337 11.5101 11.3337 11.3333V5.99996Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 2L5.99967 3.33333"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 2L10 3.33333"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12V14"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12V14"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BrandAndroid
